// hooks/useCsvReaderLogic.ts
import { useState, useCallback } from "react";
import { ParseResult } from "papaparse";

// Assuming OwCsvReader provides these event types/signatures
interface BulkOrderCsvReaderEventHandlers {
    onFileDropRejected?: () => void;
    onFileTypeRejected?: () => void;
    onFileLoadStart?: () => void;
    onFileLoadEnd?: () => void;
}

const useBulkOrderCsvLogic = () => {
    const [isProcessing, setIsProcessing] = useState(false);
    const [fileDropRejected, setFileDropRejected] = useState(false);
    const [fileTypeRejected, setFileTypeRejected] = useState(false);
    const [file, setFile] = useState<any>(undefined); // Consider better type
    const [csvData, setCsvData] = useState<ParseResult<any> | undefined>(undefined);

    // Handler for successful file load from OwCsvReader
    const csvLoaded = useCallback((data?: ParseResult<any>, loadedFile?: any) => {
        if (data) {
            setCsvData(data);
            // Optionally set file info if needed
            if (loadedFile) setFile(loadedFile);
            setFileDropRejected(false); // Clear errors on successful load
            setFileTypeRejected(false);
        } else {
            // Handle load errors if needed
            setCsvData(undefined); // Clear previous data on error
            setFile(undefined); // Clear file
        }
    }, []); // No dependencies needed for setters

    // Handlers for potential error/status events from OwCsvReader
    const onFileDropRejected = useCallback(() => {
        setFileDropRejected(true);
        setCsvData(undefined);
        setFile(undefined);
    }, []);
    const onFileTypeRejected = useCallback(() => {
        setFileTypeRejected(true);
        setCsvData(undefined);
        setFile(undefined);
    }, []);
    const onFileLoadStart = useCallback(() => setIsProcessing(true), []);
    const onFileLoadEnd = useCallback(() => setIsProcessing(false), []);

    return {
        isProcessing,
        fileDropRejected,
        fileTypeRejected,
        file,
        csvData,
        csvLoaded, // Expose the main load handler
        // Expose other handlers if the component needs to pass them down
        onFileDropRejected,
        onFileTypeRejected,
        onFileLoadStart,
        onFileLoadEnd,
    };
};

export default useBulkOrderCsvLogic;
